export default 'caseexplorerapi';
